import { useEffect } from 'react';
import {
	useSetTradeFormBaseSize,
	useSetTradeFormQuoteSize,
} from './useSetTradeFormInputState';
import useSyncedRef from 'src/hooks/utils/useSyncedRef';

interface UseTradeFormOrderTypeSyncProps {
	orderType: string;
	baseSizeStringValue: string;
	quoteSizeStringValue: string;
}

export const useSyncTradeFormOnOrderTypeChange = ({
	orderType,
	baseSizeStringValue,
	quoteSizeStringValue,
}: UseTradeFormOrderTypeSyncProps) => {
	const setBaseFormValue = useSetTradeFormBaseSize();
	const setQuoteFormValue = useSetTradeFormQuoteSize();

	// Clear zero values when order type changes.
	// We use refs for these values so as to not overwrite the user's input when
	// they're typing something like 0.0XXX.
	const baseSizeStringValueRef = useSyncedRef(baseSizeStringValue);
	const quoteSizeStringValueRef = useSyncedRef(quoteSizeStringValue);
	useEffect(() => {
		if (
			parseFloat(baseSizeStringValueRef.current) === 0 ||
			parseFloat(quoteSizeStringValueRef.current) === 0
		) {
			setBaseFormValue('');
			setQuoteFormValue('');
		}
	}, [orderType, setBaseFormValue, setQuoteFormValue]);
};
